import { Link, useParams } from "react-router-dom";
import useQueryString from "utils/hooks/useQueryString";
import queryString from 'query-string';
import SimpleDateView from "app/components/SimpleDateView";
import { AlertMessage } from "app/components/AlertMessage";

export const StoryListItem = ({ story }) => {
    const queryParams = useQueryString();
    const { school } = useParams();

    let imageUrl = story.user?.image;
    if (imageUrl === null || imageUrl === '' || story.user === null) {
        imageUrl = `${process.env.PUBLIC_URL}/static/images/user/basic_badge.png`
    }

    return (
        <li>
            <Link className={`${story.deleteYn === "Y" ? "deleteContainer" : ""}`} to={`/${school}/donghwa/story/${story.id}?${queryString.stringify(queryParams)}`}>
                <div>
                    <AlertMessage type="delete" text="삭제됨" visible={story.deleteYn === "Y"} />
                    <div className="profile">
                        <img src={imageUrl} alt="사용자 프로필 이미지" />
                        <div className="info">
                            <p>{story.user?.schoolName.replace('초등학교', '초')} {story.user?.grade}학년 {story.user?.name || story.name} </p>
                            <p className="time"><SimpleDateView date={story.createdAt} /></p>
                        </div>
                    </div>
                    <div className="brief">
                        <h4 className="title cover">{story.title}</h4>
                        <p className="desc cover">{story.content}</p>
                    </div>
                    <div className="etc">
                        <div className="count">
                            <p><i className="fa-solid fa-comment-dots"></i>{story.commentCount}</p>
                            <p><i className="fa-solid fa-thumbs-up"></i>{story.likeCount}</p>
                            <p><i className="fa-solid fa-eye"></i>{story.readCount}</p>
                        </div>
                        <span className={`label_answer ${story.replyYn === 'Y' && 'register'}`}>{story.replyYn === 'Y' ? '답변등록완료' : '답변미등록'}</span>
                    </div>
                </div>
            </Link>
        </li>
    );
}